"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../constants");
var _ProgressBar = require("./ProgressBar.styled");
var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress;
  return /*#__PURE__*/_react["default"].createElement(_ProgressBar.StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_ProgressBar.StyledBar, null, /*#__PURE__*/_react["default"].createElement(_ProgressBar.StyledProgressBar, {
    progress: progress
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ProgressBar.StyledStatusText, null, _constants.UPLOADING, " ... ", progress, "%")));
};
ProgressBar.propTypes = {
  progress: _propTypes["default"].number.isRequired
};
var _default = exports["default"] = ProgressBar;